
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/summer-overview",
      function () {
        return require("private-next-pages/[region]/[resort]/summer-overview.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/summer-overview"])
      });
    }
  